import { SaveBase } from "./SaveBase";
import { Matrix } from "../../../maths/Matrix";
export class SaveTransform {
    constructor() {
        this._matrix = new Matrix();
    }
    isSaveMark() { return false; }
    restore(runner) {
        runner._curMat = this._savematrix;
        runner._matrixChanged = false;
        SaveTransform.POOL[SaveTransform.POOL._length++] = this;
    }
    static save(runner) {
        var _saveMark = runner._saveMark;
        if ((_saveMark._saveuse & SaveBase.TYPE_TRANSFORM) === SaveBase.TYPE_TRANSFORM)
            return;
        _saveMark._saveuse |= SaveBase.TYPE_TRANSFORM;
        var no = SaveTransform.POOL;
        var o = no._length > 0 ? no[--no._length] : (new SaveTransform());
        o._savematrix = runner._curMat;
        runner._curMat = runner._curMat.copyTo(o._matrix);
        var _save = runner._save;
        _save[_save._length++] = o;
    }
}
SaveTransform.POOL = SaveBase._createArray();
